// Dev-only map registry for the preview harness. Loads bundled MapDefs so
// fixtures can hydrate a GameState offline (no API / no useMap). NOT app code.
import type { MapDef } from '@warcarp/api-types'
import usa from '../assets/maps/usa.json'
import minnesota from '../assets/maps/minnesota.json'

export const DEV_MAPS: Record<string, MapDef> = {
  usa: usa as unknown as MapDef,
  minnesota: minnesota as unknown as MapDef,
}
